import React from 'react';
import cn from 'classnames';
import ReplaceableFilePreview from '../ReplaceableFilePreview';

import s from './FilePreviewWithDisplayOptions.scss';

interface Props {
  compact?: boolean;
}

const FilePreviewWithDisplayOptions: React.FC<Props> = ({ compact }) => (
  <div className={cn(s['root'], compact && s['compact'])}>
    <ReplaceableFilePreview className={s['preview']} />
  </div>
);
FilePreviewWithDisplayOptions.displayName = 'FilePreviewWithDisplayOptions';

export default FilePreviewWithDisplayOptions;
